module.exports = __webpack_public_path__ + "media/images/pokerroom/pokerstars/step2-pict-711a575ea4399d6b30ae6f7100416339.jpg";